export const ENGLISH = "en-us";
export const ARABIC = "ar-jo";
export const China = "zh-Hans";
export const Hindi = "hi";
export const Turkish = "tr";
export const Italian = "it";
export const French = "fr";